// extracted by mini-css-extract-plugin
export var deleteModal = "_he-0";